import styled from 'styled-components';
import Colors from '../../../colors';
import * as variables from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const AffordableHomesStyles = styled.section``;

export default AffordableHomesStyles;
